import { SharedMediaApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedMediaApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new SharedMediaApi(configuration), [configuration]);
};
